export default __webpack_public_path__ + "static/media/windows.d8123e71.svg";